module.exports = __webpack_public_path__ + "media/images/icon_level_black-301c0cce2ba4b13f1a66dff5a0c6959f.png";